import { NgClass } from '@angular/common';
import { Component, computed, signal } from '@angular/core';
import {
  AnalysisRowType,
  AnalysisVersionGroupResponse,
} from '@api-response-types/analysis-version-group.response';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-enterprise';

@Component({
  selector: 'pm-group-name-cell',
  imports: [NgClass],
  template: `
    <span
      [ngClass]="{
        'text-content-interactive-default hover:underline hover:text-content-interactive-hover cursor-pointer':
          isClickable(),
      }"
    >
      {{ value() }}
    </span>
  `,
})
export class GroupNameCellComponent implements ICellRendererAngularComp {
  private readonly params =
    signal<ICellRendererParams<AnalysisVersionGroupResponse> | null>(null);

  protected value = computed(() => {
    const p = this.params();
    if (!p) return '';
    // prefer valueFormatted over value
    return p.valueFormatted ?? String(p.value ?? '');
  });

  protected isClickable = computed(() => {
    const p = this.params();
    return (
      p?.data?.rowType === AnalysisRowType.AGGREGATE &&
      !!(p as unknown as Record<string, unknown>)?.hasNextHierarchy
    );
  });

  agInit(params: ICellRendererParams<AnalysisVersionGroupResponse>): void {
    this.params.set(params);
  }

  refresh(params: ICellRendererParams<AnalysisVersionGroupResponse>): boolean {
    this.params.set(params);
    return true;
  }
}
